import React, { useState } from 'react'
import classNames from 'classnames'
import { shuffler } from 'd3-array'
import Card from 'src/components/card'

const CardGrid = ({
  className,
  children = [],
  maxColumns = 3,
  maxCards = Infinity,
  shouldShuffle = false,
  alwaysShowFirstCard = true,
}) => {
  let childCards = [...children]
  if (shouldShuffle && childCards.length) {
    const shuffle = shuffler(Math.random)
    let firstCard = null
    if (alwaysShowFirstCard) firstCard = childCards.shift()
    childCards = shuffle(childCards)
    if (alwaysShowFirstCard) childCards.unshift(firstCard)
  }
  const [cards] = useState(childCards)
  return (
    <div
      className={classNames(
        'card-grid',
        `card-count-${cards.length}`,
        className
      )}
    >
      {cards.map((card, i) => {
        return i < maxCards ? card : null
      })}
      {cards.length > 2 &&
        Array(maxColumns)
          .fill(null)
          .map((n, i) => (
            <Card
              key={`card-shim-${i}`}
              className={`card-shim card-shim-${i}`}
            />
          ))}
    </div>
  )
}

export default CardGrid
